import store from '../'

// initial state
const state = () => ({
    language: 'en'
})
  

// getters
const getters = {
    clientLanguage: state => {
        // Doing the local storage so that when we change pages we keep the language set
        let language = JSON.parse(localStorage.getItem('language'));

        // Only update the language if the language in the store is different to the language we're changing to
        if (language != state.language) {
            actions.setClientLanguage(store, language);
        }

        return state.language
    }
}


// actions
const actions = {
    setClientLanguage({commit}, language) {
        localStorage.setItem('language', JSON.stringify(language))
        //commit('SET_LANGUAGE', language);
        commit('SET_LANGUAGE', 'en');
    }
}
  
// mutations
const mutations = {
    SET_LANGUAGE: (state, val) => {
        state.language = val;
    }
}
  

export default {
    state,
    getters,
    actions,
    mutations
}